import React from "react";

const MainContent = () => {
  return (
    <div id="maincontent">
      <h1 className="title">Rainference.com</h1>
      {/* Clean straight line */}
      <hr className="straight-line" />

      <p>
      Forget overpriced, closed systems. <b>Rainference</b> gives you blazing-fast 
      open-source LLMs that work for everyone—devs, teams, or full-scale production.
      </p>

      <p>
        <b>Why Rainference?</b>
      </p>
      <ul>
        <li>• Cheaper Than Closed Models: Stop overpaying save more than 70%. Get world-class AI without the premium price tag.</li>
        <li>• Insanely Fast: Low latency, instant time-to-first-token(TTFT) because waiting sucks.</li>
        <li>• Real-Time Streaming: WebSockets, WebRTC, multimodal capabilities—build apps that actually feel alive.</li>
        <li>• Do More, Effortlessly: Structured outputs, function calling, multimodality—just works out of the box</li>
        <li>• Scales Without Breaking a prod: Whether you’re testing, building for your team, or scaling to millions, our autoscaling infra handles it. Zero headaches, zero extra cost.</li>  
      </ul>

      <div>
        <p>
          <b>"Let the Intelligence Flow Like Rain"</b>
          <ul>
          Rainference is how you build AI that works—fast, flexible, affordable. No fluff. Just power.
          </ul>
          </p>
      </div>
      <p>
        <b>Coming Soon..</b>
        <ul>
        When we launch, you’ll be ready to ship intelligence.
        </ul>
      </p>

    </div>

        
  );
};

export default MainContent;


